import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IdsAccordionModule,
  IdsActionButtonModule,
  IdsAlertModule,
  IdsCheckboxModule,
  IdsContextualButtonModule,
  IdsFormFieldModule,
  IdsFormMessageModule,
  IdsFormSelectionGroupModule,
  IdsFormSelectionModule,
  IdsIconModule,
  IdsInputModule,
  IdsTooltipModule,
  IdsMainButtonModule,
  IdsMaskModule,
  IdsRadioButtonModule,
  IdsSelectModule,
  IdsProgressBarModule,
  IdsOverlayOriginModule,
  IdsShimmerModule,
  IdsLoadingModule,
  IdsIconButtonModule,
  IdsListModule,
  IdsModalModule,
  IdsDirectionalButtonModule,
  IdsListItemComponent,
  IdsListComponent,
  IdsDatepickerModule
} from '@ids/angular';

import { GenericStepHeaderComponent } from '../shared/components/generic-step-header/generic-step-header.component';
import { GenericStartFormComponent } from '../shared/components/generic-start-form/generic-start-form.component';
import { GenericEndFormComponent } from './components/generic-end-form/generic-end-form.component';
import { DomainInputSelectComponent } from './components/domain-input-select/domain-input-select.component';
import { CepSearchComponent } from './components/cep-search/cep-search.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ReloginAlertComponent } from './components/relogin-alert/relogin-alert.component';
import { ErrorScreenComponent } from './components/error-screen/error-screen.component';
import { AlertToastNotificationComponent } from './components/alert-toast-notification/alert-toast-notification.component';
import { PropertyRegimeLabelPipe } from './pipes/property-regime-label/property-regime-label.pipe';
import { SimNaoPipe } from './pipes/sim-nao/sim-nao.pipe';
import { ResidenciaOuOutroPipe } from './pipes/residencia-ou-outro/residencia-ou-outro.pipe';
import { AccountTypeLabelPipe } from './pipes/account-type-label/account-type-label.pipe';
import { UppercaseInputDirective } from './directives/uppercase-input.directive';
import { ModalBackButtonComponent } from './components/modal-back-button/modal-back-button.component';
const baseModules = [CommonModule, FormsModule, ReactiveFormsModule];

const idsModules = [
  IdsAccordionModule,
  IdsActionButtonModule,
  IdsAlertModule,
  IdsCheckboxModule,
  IdsContextualButtonModule,
  IdsFormFieldModule,
  IdsFormMessageModule,
  IdsFormSelectionGroupModule,
  IdsFormSelectionModule,
  IdsIconModule,
  IdsInputModule,
  IdsMainButtonModule,
  IdsMaskModule,
  IdsRadioButtonModule,
  IdsSelectModule,
  IdsProgressBarModule,
  IdsOverlayOriginModule,
  IdsShimmerModule,
  IdsLoadingModule,
  IdsIconButtonModule,
  IdsListModule,
  IdsModalModule,
  IdsDirectionalButtonModule,
  IdsListComponent,
  IdsListItemComponent,
  IdsTooltipModule,
  IdsDatepickerModule
];

const sharedModules = [
  GenericStepHeaderComponent,
  GenericStartFormComponent,
  GenericEndFormComponent,
  DomainInputSelectComponent,
  CepSearchComponent,
  LoadingComponent,
  ReloginAlertComponent,
  ErrorScreenComponent,
  AlertToastNotificationComponent,
];

@NgModule({
  declarations: [sharedModules, PropertyRegimeLabelPipe, SimNaoPipe, ResidenciaOuOutroPipe, AccountTypeLabelPipe, UppercaseInputDirective, ModalBackButtonComponent],
  imports: [baseModules, idsModules],
  bootstrap: [],
    exports: [baseModules, idsModules, sharedModules, PropertyRegimeLabelPipe, SimNaoPipe, ResidenciaOuOutroPipe, AccountTypeLabelPipe, UppercaseInputDirective, ModalBackButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
